import { ImageIcon } from "lucide-react";

export function ImageSlot({ label, dimensions, className = "", aspect = "aspect-[4/3]", icon: Icon = ImageIcon }) {
  return (
    <div
      className={`${aspect} w-full bg-slate-200/80 border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center text-center p-4 overflow-hidden ${className}`}
      data-testid="image-slot"
    >
      <Icon className="text-slate-400 mb-2 stroke-[1.5]" size={32} />
      {label && <span className="text-[11px] font-mono font-semibold text-slate-600 uppercase tracking-wider break-all px-2">{label}</span>}
      {dimensions && <span className="text-[10px] font-mono text-slate-400 mt-1">{dimensions}</span>}
    </div>
  );
}
